import Box from '@mui/material/Box';
import styled from '@mui/material/styles/styled';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import NoContent from '../../../sections/no-content/NoContent';
import { tableDisplay } from '../crawlerUtils';

const StyledTableBody = styled(TableBody)({
  '& tr:last-child > *': {
    borderBottom: 'unset',
  },
});

const ArgumentsTable = ({ args }) => {
  const { t } = useTranslation();

  return args ? (
    <TableContainer>
      <Table size="small">
        <StyledTableBody>
          {Object.entries(args).map((field) =>
            tableDisplay(field[0], field[1], field[0])
          )}
        </StyledTableBody>
      </Table>
    </TableContainer>
  ) : (
    <Box sx={{ mb: 1 }}>
      <NoContent title={t('stepper.noArguments', { ns: 'crawler' })} />
    </Box>
  );
};

ArgumentsTable.propTypes = {
  args: PropTypes.object,
};

export default ArgumentsTable;
